module.exports = "/images/sbl-logo-blue.png?05ef4881f701321f9880337ab1229d13";


//////////////////
// WEBPACK FOOTER
// ./resources/images/sbl-logo-blue.png
// module id = ./resources/images/sbl-logo-blue.png
// module chunks = 0